import { map } from "rxjs/operators";
import { ofType } from "redux-observable";
import { types } from "../../actions/order";
import { actions, getters } from "../..";
import { types as syncTypes } from "@kofile/ko-search-action-types";
import { newApiTypes } from "../../actions/order";
import { propSatisfies, equals, path, pathOr } from "ramda";

export const requestRefund = (actionStream, state$) =>
  actionStream.pipe(
    ofType(types.REQUEST_REFUND),
    map((action) => {
      const state = state$.value;
      const { payload } = action;
      const orderRefund = getters.order.orderRefund(state, payload);

      return {
        type: syncTypes.REQUEST_REFUND_1,
        payload: orderRefund,
      };
    })
  );

export const fetchOrderOnRefundComplete = (actionStream, state$) => {
  const types = {
    completed: syncTypes.PROCEED_REFUND_COMPLETE_FULFILLED_0,
    rejected: syncTypes.PROCEED_REFUND_REJECT_FULFILLED_0,
  };

  return actionStream.pipe(
    ofType(types.completed, types.rejected),
    map(({ payload }) => {
      const state = state$.value;
      const { county, refund } = state;
      const order = getters.order.order(state);
      const refundOrderId = path(["data", "orderId"], refund);
      const refundId = payload.id || pathOr(null, ["data", "id"], refund);

      const useFetchARefund = propSatisfies(
        equals(true),
        "useFetchARefund",
        getters.configuration.flips(county, state)
      );

      if (useFetchARefund) {
        return actions.refund.fetch({
          id: parseInt(refundId),
          orderId: parseInt(refundOrderId),
        });
      }

      return {
        type: newApiTypes.fetchOrder,
        payload: { id: order.orderId },
      };
    })
  );
};

export default [requestRefund, fetchOrderOnRefundComplete];
